module.exports = __webpack_public_path__ + "static/media/logo_circle.e0562b8c.png";